import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  UserPlus, ArrowLeft, Calculator, Search, 
  UserCheck, BrainCircuit, ScanFace, Users, Briefcase, FileSearch, CalendarCheck, Check, MessageSquareMore, ShieldCheck
} from 'lucide-react';

// --- IMÁGENES DEL CARRUSEL (Sección Dolor) ---
const SP_CAROUSEL_IMAGES = [
  "https://zaphy.com.co/wp-content/uploads/2026/01/IMG-20250617-WA0140.jpg",
  "https://zaphy.com.co/wp-content/uploads/2026/01/seleccionpersonal2.jpeg",
  "https://zaphy.com.co/wp-content/uploads/2026/01/seleccionpersonal3.jpeg"
];

const SeleccionPersonal = ({ language }) => { 
  
  const navigate = useNavigate();
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % SP_CAROUSEL_IMAGES.length);
    }, 4000); 
    return () => clearInterval(interval);
  }, []);

  // --- DICCIONARIO DE TEXTOS CON MÁXIMA DENSIDAD SEMÁNTICA SEO Y ENFOQUE HORMOZI ---
  const t = {
    es: {
      back: "Volver al Inicio",
      heroTag: "Agencia de Reclutamiento y Headhunting en Colombia",
      heroTitle: "Selección de Personal Experta:",
      heroSubtitle: "Encuentra al Candidato Ideal",
      heroDesc: "Deja de perder tiempo valioso en entrevistas fallidas con candidatos que no encajan. En Zaphy estructuramos perfiles, aplicamos pruebas psicotécnicas avanzadas y filtramos el talento mediante psicología organizacional profunda para entregarte ternas listas para decidir.",
      heroBtnQuote: "Iniciar Proceso",
      heroBtnWhatsApp: "Escríbenos por WhatsApp",
      imgBadgeTitle: "Filtro Técnico",
      imgBadgeDesc: "Match 100% Con el Perfil",
      painTag: "¿Te ha pasado?",
      painTitle: "Equivocarse al contratar personal sale muy caro",
      painDesc: "El costo de integrar a un colaborador incorrecto puede equivaler hasta 3 veces su salario anual en pérdidas. Pierdes dinero en entrenamiento, desgastas la moral del equipo de trabajo y frenas tu facturación. Además, revisar cientos de hojas de vida desalineadas consume tu enfoque estratégico.",
      painHighlight: "No busques más agujas en un pajar. Delegar tu reclutamiento con los expertos de Zaphy te garantiza contratar perfiles calificados que impulsarán los resultados de tu negocio.",
      painBadgeTitle: "Resultado",
      painBadgeDesc: "Ahorro de Tiempo Real",
      
      // Banner de Inversión de Riesgo Estilo Hormozi
      bannerTitle: "Filtros Técnicos Rigurosos con Garantía de Reposición",
      bannerDesc: "Asumimos el riesgo operativo por ti. Nuestro proceso incluye la estructuración milimétrica del perfil, bases de datos premium pagas, entrevistas por competencias conductuales y una entrega integral de informe técnico. Si el candidato seleccionado no supera el periodo de prueba, realizamos una nueva búsqueda sin costos adicionales.",
      
      gridTitle: "¿Cómo garantizamos el éxito de la contratación?",
      gridSubtitle: "Combinamos metodologías ágiles de atracción de talento con análisis psicológicos rigurosos para filtrar lo bueno de lo extraordinario.",
      cards: [
        { title: "Estructuración del Perfil & Publicación", desc: "Definimos técnicamente las competencias del cargo y creamos ofertas de empleo atractivas en portales premium y redes profesionales como LinkedIn." },
        { title: "Atracción & Reclutamiento 360°", desc: "Búsqueda activa y headhunting especializado en nuestras propias bases de datos de talento calificado y canales cerrados de la industria." },
        { title: "Filtrado de Hojas de Vida", desc: "Revisión exhaustiva y pre-filtro curricular de perfiles para comprobar de forma estricta la compatibilidad inicial con los requerimientos del cargo." },
        { title: "Entrevistas por Competencias", desc: "Entrevistas profundas dirigidas por psicólogos organizacionales expertos para validar experiencia laboral real, habilidades blandas y fit cultural." },
        { title: "Pruebas Psicotécnicas Avanzadas", desc: "Evaluación objetiva de rasgos de personalidad, coeficientes aptitudinales, valores y competencias conductuales requeridas para la vacante." },
        { title: "Elaboración y Entrega de Informe", desc: "Te entregamos un informe técnico estructurado con los puntajes de compatibilidad, ventajas competitivas y observaciones clave de la terna final." },
        { title: "Verificación de Antecedentes", desc: "Estudio riguroso de referencias laborales históricas, títulos académicos y antecedentes judiciales para mitigar cualquier riesgo de fraude o suplantación." },
        { title: "Garantía de Satisfacción Total", desc: "Protegemos tu inversión comercial. Si el colaborador elegido no se adapta durante el marco legal de prueba, reactivamos el proceso sin cobrarte un solo peso más." }
      ],
      seoTitle: 'Preguntas Frecuentes sobre Empresas de Reclutamiento de Personal',
      seoSubtitle: 'Resolvemos tus dudas sobre procesos de Headhunting, pruebas organizacionales y la suite de contratación de Zaphy.',
      faqs: [
        { q: '¿Qué ventajas tiene contratar una agencia de selección de personal externa?', a: 'Externalizar tu reclutamiento te ahorra decenas de horas administrativas y reduce el riesgo de rotación laboral. Te permite delegar las fases tediosas de pre-filtro y validación técnica en psicólogos especializados en talento humano, garantizando que solo dediques tiempo a entrevistar a los tres mejores candidatos finalistas.' },
        { q: '¿Cómo evalúa Zaphy si un candidato realmente tiene las competencias blandas requeridas?', a: 'Utilizamos entrevistas estructuradas bajo incidentes críticos y aplicamos baterías de pruebas psicotécnicas modernas y de conocimiento adaptadas al cargo. Evaluamos rasgos de adaptabilidad, liderazgo, tolerancia a la frustración y compatibilidad con la cultura y valores de tu organización.' },
        { q: '¿Qué incluye el informe técnico que entregan al final del proceso?', a: 'El informe consolidado es una radiografía del candidato. Incluye el análisis cuantitativo de sus pruebas psicotécnicas, el resumen cualitativo de la entrevista por competencias efectuada por nuestro equipo, la validación de sus referencias laborales anteriores y un concepto profesional sobre su idoneidad para la vacante.' },
        { q: '¿Tienen cobertura para vacantes operativas, administrativas y de servicio doméstico?', a: '¡Sí! Contamos con metodologías diferenciadas según la complejidad del cargo. Cubrimos desde puestos operativos, mandos medios y headhunting gerencial de alta dirección, hasta procesos especializados e independientes como la selección y contratación de servicio doméstico blindado.' },
        { q: '¿Cómo funciona la Garantía de Reposición en los procesos de selección?', a: 'Es nuestra promesa de valor absoluta estilo Alex Hormozi: si por cualquier motivo de fuerza mayor, rendimiento o adaptación el candidato elegido se retira o es desvinculado durante su periodo de prueba reglamentario, Zaphy asume la responsabilidad total de iniciar un nuevo proceso completo de reclutamiento a costo cero para tu PyME.' }
      ],
      ctaTitle: "Tu próximo empleado estrella está a un clic de distancia",
      ctaDesc: "Déjanos la fatiga del reclutamiento a nosotros y enfócate en lo que mejor sabes hacer: liderar el crecimiento de tu negocio.",
      ctaBtnQuote: "Iniciar Proceso",
      ctaBtnSchedule: "Agendar Asesoría",
      ctaBtnWhatsApp: "Hablemos por WhatsApp"
    },
    en: {
      back: "Back to Home",
      heroTag: "Recruitment and Headhunting Agency in Colombia",
      heroTitle: "Expert Personnel Selection:",
      heroSubtitle: "Find the Ideal Candidate",
      heroDesc: "Stop wasting valuable time on failed interviews with candidates who do not fit. At Zaphy, we structure profiles, apply advanced psychotechnical tests, and filter talent through deep organizational psychology to deliver shortlists ready to decide.",
      heroBtnQuote: "Start Process",
      heroBtnWhatsApp: "Chat on WhatsApp",
      imgBadgeTitle: "Technical Filter",
      imgBadgeDesc: "100% Profile Match",
      painTag: "Has it happened to you?",
      painTitle: "Making a mistake when hiring staff is very expensive",
      painDesc: "The cost of integrating the wrong collaborator can equal up to 3 times their annual salary in losses. You lose money on constant training, drain team morale, and stall your invoicing. Plus, reviewing hundreds of unaligned resumes consumes your strategic focus.",
      painHighlight: "Stop looking for needles in a haystack. Delegating your recruitment with Zaphys experts guarantees you hire qualified profiles that will drive your business results.",
      painBadgeTitle: "Result",
      painBadgeDesc: "Real Time Savings",
      
      bannerTitle: "Rigorous Technical Filters with Replacement Guarantee",
      bannerDesc: "We assume the operational risk for you. Our process includes millimeter structuring of the profile, paid premium databases, behavioral competency interviews, and a comprehensive structured report delivery. If the selected candidate does not pass the trial period, we carry out a new search at no additional cost.",
      
      gridTitle: "How do we guarantee hiring success?",
      gridSubtitle: "We combine agile talent attraction methodologies with rigorous psychological analysis to filter the good from the extraordinary.",
      cards: [
        { title: "Profile Structuring & Publication", desc: "We technically define the competencies of the position and create attractive job offers on premium portals and professional networks like LinkedIn." },
        { title: "360° Attraction & Recruitment", desc: "Active search and specialized headhunting in our own qualified talent databases and closed industry channels." },
        { title: "Resume Screening & Pre-filter", desc: "Exhaustive review and curricular pre-filtering of profiles to strictly verify initial compatibility with the position requirements." },
        { title: "Competency-Based Interviews", desc: "In-depth interviews led by expert organizational psychologists to validate real work experience, soft skills, and cultural fit." },
        { title: "Advanced Psychotechnical Testing", desc: "Objective evaluation of personality traits, aptitudinal coefficients, values, and behavioral competencies required for the vacancy." },
        { title: "Structuring & Report Delivery", desc: "We deliver a technical report with compatibility scores, competitive advantages, and key observations of the final shortlist." },
        { title: "Background & Reference Verification", desc: "Rigorous study of historic work references, academic degrees, and judicial backgrounds to mitigate any fraud risk." },
        { title: "Total Satisfaction Guarantee", desc: "We protect your commercial investment. If the chosen collaborator leaves during the legal trial frame, we reactivate the process at no extra cost." }
      ],
      seoTitle: 'Frequently Asked Questions about Recruitment Agencies',
      seoSubtitle: 'We solve your doubts about Headhunting processes, organizational tests, and Zaphys recruitment suite.',
      faqs: [
        { q: 'What are the advantages of hiring an external recruitment agency?', a: 'Outsourcing your recruitment saves dozens of administrative hours and reduces labor turnover risk. It allows you to delegate the tedious phases of pre-filtering and technical validation to psychologists specialized in human talent, ensuring you only spend time interviewing the three best finalist candidates.' },
        { q: 'How does Zaphy evaluate if a candidate truly has the required soft skills?', a: 'We use structured critical incident interviews and apply modern psychotechnical and knowledge testing batteries tailored to the position. We assess adaptability, leadership, frustration tolerance, and compatibility with your culture.' },
        { q: 'What is included in the technical report delivered at the end of the process?', a: 'The consolidated report is a snapshot of the candidate. It includes the quantitative analysis of their psychotechnical tests, the qualitative summary of the interview conducted by our team, verification of references, and a professional concept.' },
        { q: 'Do you cover operational, administrative, and domestic service vacancies?', a: 'Yes! We have differentiated methodologies based on the complexity of the position. We cover everything from operational roles, middle management, and executive headhunting, to specialized processes like shielded domestic service selection.' },
        { q: 'How does the Replacement Guarantee work in selection processes?', a: 'It is our absolute Alex Hormozi style value promise: if for any reason the chosen candidate leaves or is dismissed during their legal trial period, Zaphy assumes total responsibility for starting a new complete recruitment process at zero cost.' }
      ],
      ctaTitle: "Your next star employee is just a click away",
      ctaDesc: "Leave the recruitment fatigue to us and focus on what you do best: leading your PyMEs growth.",
      ctaBtnQuote: "Start Process",
      ctaBtnSchedule: "Schedule Advisory",
      ctaBtnWhatsApp: "Chat via WhatsApp"
    }
  };

  const text = t[language] || t.es;

  // Canal express de redirección directa a tu canal comercial de WhatsApp
  const handleWhatsAppRedirect = () => {
    const targetUrl = `https://api.whatsapp.com/send?phone=573114044203&text=${encodeURIComponent("¡Hola, Zaphy! 🚀 Estuve revisando el componente de Selección de Personal en su web y quiero solicitar una cotización directa para cubrir una vacante urgente en mi empresa.")}`;
    window.open(targetUrl, '_blank');
  };

  return (
    <div className="animate-[fadeIn_0.5s_ease-out] pt-32 pb-20 min-h-screen bg-gray-50 font-[Poppins]">
      
      {/* --- 1. HERO SECTION (CON INTERFAZ DE DOBLE ACCIÓN EN COLOR CORPORATIVO) --- */}
      <div className="relative bg-[#0F172A] text-white py-24 overflow-hidden mb-16">
         <div className="absolute inset-0 opacity-20 bg-cover bg-center" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=1200&q=80)` }}></div>
         <div className="absolute inset-0 bg-gradient-to-r from-[#0F172A] via-[#0F172A]/90 to-[#EC4899]/40"></div>
         
         <div className="max-w-7xl mx-auto px-4 relative z-10">
            <button onClick={() => navigate('/')} className="flex items-center gap-2 text-white/70 hover:text-white mb-6 transition-colors font-medium">
               <ArrowLeft size={20} /> {text.back}
            </button>
            
            <div className="flex flex-col md:flex-row gap-12 items-center">
                <div className="flex-1">
                    <div className="flex items-center gap-4 mb-4">
                        <div className="p-3 rounded-xl bg-[#EC4899]/20 text-[#EC4899] border border-[#EC4899]/30">
                            <UserPlus size={40} />
                        </div>
                        <span className="text-[#EC4899] font-bold tracking-widest uppercase text-xs md:text-sm">{text.heroTag}</span>
                    </div>
                    
                    <h1 className="text-3xl md:text-5xl font-extrabold mb-6 leading-tight">
                    {text.heroTitle} <br/>
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#EC4899] to-purple-400">{text.heroSubtitle}</span>
                    </h1>
                    
                    <p className="text-lg text-gray-300 max-w-2xl leading-relaxed mb-8">
                    {text.heroDesc}
                    </p>

                    {/* INTERFAZ DE DOBLE BOTÓN OPTIMIZADO PARA TRÁFICO ORGÁNICO Y DE PAUTA */}
                    <div className="flex flex-wrap gap-4">
                        <button 
                          onClick={() => navigate('/cotizador')} 
                          className="bg-[#EC4899] text-white font-bold py-4 px-8 rounded-2xl shadow-lg shadow-pink-900/40 transition-all flex items-center gap-2 transform hover:-translate-y-1 hover:bg-pink-600 text-sm uppercase tracking-wide"
                        >
                            <Calculator size={20}/> {text.heroBtnQuote}
                        </button>

                        <button 
                          onClick={handleWhatsAppRedirect} 
                          className="bg-transparent border-2 border-[#EC4899] text-[#EC4899] font-bold py-4 px-8 rounded-2xl transition-all flex items-center gap-2 transform hover:-translate-y-1 hover:bg-[#EC4899] hover:text-white shadow-lg shadow-pink-500/5 text-sm uppercase tracking-wide"
                        >
                            <MessageSquareMore size={20}/> {text.heroBtnWhatsApp}
                        </button>
                    </div>
                </div>

                {/* IMAGEN HERO */}
                <div className="w-full max-w-md mt-10 md:mt-0">
                    <div className="relative group">
                        <div className="absolute -inset-1 bg-gradient-to-r from-[#EC4899] to-purple-600 rounded-2xl blur opacity-30 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
                        <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/10 bg-[#0F172A]">
                             <img 
                                src="https://zaphy.com.co/wp-content/uploads/2026/01/seleccionPersonal.png" 
                                alt="Filtro de Hojas de Vida y Contratación de Personal | Zaphy" 
                                className="w-full h-auto object-cover transform transition-transform duration-500 group-hover:scale-105"
                                onError={(e) => { e.target.style.display = 'none'; }}
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/80 via-transparent to-transparent opacity-60"></div>
                            <div className="absolute bottom-4 left-4 bg-white/10 backdrop-blur-md border border-white/20 p-3 rounded-xl flex items-center gap-3">
                                <div className="bg-[#EC4899] p-1.5 rounded-full text-white"><UserCheck size={16} /></div>
                                <div>
                                    <p className="text-xs text-pink-200 uppercase font-bold">{text.imgBadgeTitle}</p>
                                    <p className="text-sm font-bold text-white">{text.imgBadgeDesc}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         </div>
      </div>

      {/* --- 2. EL PROBLEMA (CARRUSEL MÓVIL OPTIMIZADO) --- */}
      <div className="max-w-7xl mx-auto px-4 mb-16">
          <div className="bg-white rounded-[40px] p-8 md:p-12 shadow-xl border border-gray-100 flex flex-col md:flex-row items-center gap-12 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-pink-50 rounded-bl-[100px] z-0"></div>
              
              <div className="md:w-1/2 relative z-10">
                  <div className="inline-flex items-center gap-2 bg-purple-50 text-purple-600 px-4 py-2 rounded-full font-bold text-sm mb-4 border border-purple-100">
                      <Search size={16} /> {text.painTag}
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-4">{text.painTitle}</h2>
                  <p className="text-gray-600 text-lg leading-relaxed mb-6">{text.painDesc}</p>
                  <p className="font-bold text-gray-800 border-l-4 border-[#EC4899] pl-4">{text.painHighlight}</p>
              </div>

              {/* Columna Derecha: Carrusel de Imágenes */}
              <div className="w-full md:w-1/2 relative z-10 mt-12 md:mt-0">
                  <div className="absolute -inset-4 bg-pink-100 rounded-[40px] transform -rotate-2 z-0"></div>
                  
                  <div className="relative z-10 rounded-[30px] shadow-lg w-full h-64 md:h-80 overflow-hidden bg-gray-200">
                      {SP_CAROUSEL_IMAGES.map((img, idx) => (
                          <img 
                            key={idx}
                            src={img} 
                            alt={`Headhunting de Personal Calificado ${idx + 1}`} 
                            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${idx === currentImage ? 'opacity-100' : 'opacity-0'}`}
                            onError={(e) => { e.target.src = "https://via.placeholder.com/800x600/EC4899/FFFFFF?text=Seleccion"; }}
                          />
                      ))}

                      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 z-20">
                          {SP_CAROUSEL_IMAGES.map((_, idx) => (
                              <div 
                                key={idx} 
                                className={`w-2 h-2 rounded-full transition-all duration-300 ${idx === currentImage ? 'bg-[#EC4899] w-4' : 'bg-white/50'}`}
                              />
                          ))}
                      </div>
                  </div>

                  <div className="absolute -bottom-6 -left-6 z-20 bg-white p-4 rounded-2xl shadow-xl border border-gray-100 flex items-center gap-3">
                      <div className="bg-green-100 p-2 rounded-full text-green-600"><Check size={24}/></div>
                      <div><p className="text-xs text-gray-500 font-bold uppercase">{text.painBadgeTitle}</p><p className="text-sm font-bold text-gray-900">{text.painBadgeDesc}</p></div>
                  </div>
              </div>
          </div>
      </div>

      {/* --- BANNER ESTRATÉGICO DE INVERSIÓN DE RIESGO DE ALTA CONVERSIÓN --- */}
      <div className="max-w-7xl mx-auto px-4 mb-24">
         <div className="bg-gradient-to-r from-slate-900 to-slate-800 rounded-[30px] p-8 md:p-10 border border-slate-700/50 shadow-xl flex flex-col md:flex-row items-center gap-8">
            <div className="bg-pink-500/10 p-4 rounded-2xl text-pink-400 shrink-0 border border-pink-500/20">
               <ShieldCheck size={40} />
            </div>
            <div>
               <h3 className="text-xl md:text-2xl font-bold text-white mb-2">{text.bannerTitle}</h3>
               <p className="text-slate-300 text-sm md:text-base leading-relaxed">{text.bannerDesc}</p>
            </div>
         </div>
      </div>

      {/* --- 3. GRID DE SERVICIOS (8 MÓDULOS DE ATRACCIÓN DE TALENTO 360°) --- */}
      <div className="max-w-7xl mx-auto px-4 mb-24">
         <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">{text.gridTitle}</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">{text.gridSubtitle}</p>
         </div>

         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {text.cards.map((card, idx) => {
               const icons = [FileSearch, BrainCircuit, ScanFace, UserCheck, Users, Briefcase, FileSearch, ShieldCheck];
               const Icon = icons[idx] || Search;
               const borderColors = ['hover:border-pink-400', 'hover:border-purple-400', 'hover:border-blue-400', 'hover:border-green-400', 'hover:border-indigo-400', 'hover:border-orange-400', 'hover:border-magenta-400', 'hover:border-emerald-400'];
               const iconColors = ['text-pink-600 bg-pink-50', 'text-purple-600 bg-purple-50', 'text-blue-600 bg-blue-50', 'text-green-600 bg-green-50', 'text-indigo-600 bg-indigo-50', 'text-orange-600 bg-orange-50', 'text-rose-600 bg-rose-50', 'text-emerald-600 bg-emerald-50'];
               return (
                  <div key={idx} className={`bg-white p-6 rounded-3xl border border-gray-100 hover:shadow-xl transition-all group ${borderColors[idx]}`}>
                      <div className={`w-12 h-12 ${iconColors[idx]} rounded-2xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform`}>
                         <Icon size={24} />
                      </div>
                      <h3 className="text-lg font-bold text-gray-900 mb-2">{card.title}</h3>
                      <p className="text-gray-500 text-xs md:text-sm leading-relaxed">{card.desc}</p>
                  </div>
               );
            })}
         </div>
      </div>

      {/* --- 3.5: BLOQUE DE PREGUNTAS FRECUENTES (SEO BOOST SEMÁNTICO) --- */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mb-24">
         <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-2">{text.seoTitle}</h2>
            <p className="text-gray-500 text-xs md:text-sm">{text.seoSubtitle}</p>
         </div>
         <div className="space-y-4">
            {text.faqs.map((faq, idx) => (
               <div key={idx} className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:border-slate-200 transition-all">
                  <h3 className="text-sm md:text-base font-bold text-gray-950 mb-2 flex items-start gap-2">
                     <span className="text-pink-600 shrink-0">❓</span> {faq.q}
                  </h3>
                  <p className="text-gray-600 text-xs md:text-sm leading-relaxed pl-6">{faq.a}</p>
               </div>
            ))}
         </div>
      </div>

      {/* --- 4. CTA FINAL --- */}
      <div className="max-w-4xl mx-auto px-4 text-center">
         <div className="bg-gradient-to-br from-[#0F172A] to-pink-900 rounded-[40px] p-12 text-white shadow-2xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#EC4899]/20 rounded-full blur-3xl -mr-16 -mt-16"></div>
            
            <h2 className="text-3xl md:text-5xl font-extrabold mb-6 relative z-10">{text.ctaTitle}</h2>
            <p className="text-pink-100 text-base md:text-lg mb-8 max-w-2xl mx-auto relative z-10">{text.ctaDesc}</p>
            
            <div className="flex flex-col sm:flex-row justify-center gap-4 relative z-10">
                <button 
                  onClick={() => navigate('/cotizador')} 
                  className="bg-white text-pink-900 font-bold py-4 px-8 rounded-xl shadow-lg hover:bg-pink-50 transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 text-xs md:text-sm uppercase tracking-wide"
                >
                    <Calculator size={20}/>
                    {text.ctaBtnQuote}
                </button>

                <button 
                    onClick={handleWhatsAppRedirect}
                    className="bg-emerald-600 text-white font-bold py-4 px-8 rounded-xl shadow-lg hover:bg-emerald-700 transition-all transform hover:-translate-y-1 relative z-10 flex items-center justify-center gap-2 text-xs md:text-sm uppercase tracking-wide"
                >
                    <MessageSquareMore size={20}/>
                    {text.ctaBtnWhatsApp}
                </button>

                <a 
                  href="https://calendar.app.google/UYZ2ERubo552yRg19" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-transparent border-2 border-white text-white font-bold py-4 px-8 rounded-xl hover:bg-white/10 transition-all flex items-center justify-center gap-2 text-xs md:text-sm uppercase tracking-wide"
                >
                    <CalendarCheck size={20}/>
                    {text.ctaBtnSchedule}
                </a>
            </div>
         </div>
      </div>

    </div>
  );
};

export default SeleccionPersonal;